import httpRequest from "@/auth/http-client";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import { ITag, ITagInput } from "@/interfaces/tag.interface";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class TagService {
  private baseUrl = "api/v1/tag";

  async getAll(pagination: RequestPagination): Promise<PaginatedResponse<ITag>> {
    const paginationQuery = buildPaginationQuery(pagination);
    const tags = await httpRequest.get(`${this.baseUrl}?${paginationQuery}`);
    return tags;
  }

  async filter(
    filter: IFilter<ITag>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<ITag>> {
    const paginationQuery = buildPaginationQuery(pagination);

    const response = await httpRequest.post(`${this.baseUrl}/filter?${paginationQuery}`, {
      filter,
    });

    return response;
  }

  async create(formData: ITagInput): Promise<ITag> {
    return await httpRequest.post<ITag>(this.baseUrl, formData);
  }

  async getById(tagId: number): Promise<ITag> {
    const tag = await httpRequest.get(`${this.baseUrl}/${tagId}`);
    return tag;
  }

  async update(formData: ITagInput, tagId: number): Promise<void> {
    await httpRequest.put(`${this.baseUrl}/${tagId}`, formData);
  }

  async delete(tagId: number): Promise<void> {
    await httpRequest.delete(`${this.baseUrl}/${tagId}`);
  }
}

const tagService = new TagService();
export default tagService;
